import { render } from "./IconStatus.vue?vue&type=template&id=03e8b7b7"
import script from "./IconStatus.vue?vue&type=script&lang=js"
export * from "./IconStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__